export default __webpack_public_path__ + "resources/icons/d500-8b3a.png";